var cov_ib1vah66i = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Image/Gallery.tsx",
      hash = "8ccc2bf975814abc22ae292cbd04309f6a78fc99",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Image/Gallery.tsx",
    statementMap: {
      "0": {
        start: {
          line: 22,
          column: 21
        },
        end: {
          line: 24,
          column: 1
        }
      },
      "1": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 16
        }
      },
      "2": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 43,
          column: 5
        }
      },
      "3": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 52
        }
      },
      "4": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 48
        }
      },
      "5": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 20
        }
      },
      "6": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 26
        }
      },
      "7": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 29
        }
      },
      "8": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 77
        }
      },
      "9": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 32
        }
      },
      "10": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 104
        }
      },
      "11": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 27
        }
      },
      "12": {
        start: {
          line: 67,
          column: 23
        },
        end: {
          line: 67,
          column: 40
        }
      },
      "13": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 80,
          column: 5
        }
      },
      "14": {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 70,
          column: 34
        }
      },
      "15": {
        start: {
          line: 71,
          column: 8
        },
        end: {
          line: 73,
          column: 71
        }
      },
      "16": {
        start: {
          line: 71,
          column: 31
        },
        end: {
          line: 71,
          column: 48
        }
      },
      "17": {
        start: {
          line: 72,
          column: 13
        },
        end: {
          line: 73,
          column: 71
        }
      },
      "18": {
        start: {
          line: 72,
          column: 42
        },
        end: {
          line: 72,
          column: 68
        }
      },
      "19": {
        start: {
          line: 73,
          column: 13
        },
        end: {
          line: 73,
          column: 71
        }
      },
      "20": {
        start: {
          line: 76,
          column: 8
        },
        end: {
          line: 78,
          column: 15
        }
      },
      "21": {
        start: {
          line: 77,
          column: 10
        },
        end: {
          line: 77,
          column: 46
        }
      },
      "22": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 84,
          column: 30
        }
      },
      "23": {
        start: {
          line: 84,
          column: 24
        },
        end: {
          line: 84,
          column: 30
        }
      },
      "24": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 85,
          column: 22
        }
      },
      "25": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 34
        }
      },
      "26": {
        start: {
          line: 86,
          column: 28
        },
        end: {
          line: 86,
          column: 34
        }
      },
      "27": {
        start: {
          line: 87,
          column: 18
        },
        end: {
          line: 87,
          column: 35
        }
      },
      "28": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 31
        }
      },
      "29": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 46
        }
      },
      "30": {
        start: {
          line: 90,
          column: 26
        },
        end: {
          line: 90,
          column: 46
        }
      },
      "31": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 45
        }
      },
      "32": {
        start: {
          line: 91,
          column: 26
        },
        end: {
          line: 91,
          column: 45
        }
      },
      "33": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 95,
          column: 12
        }
      },
      "34": {
        start: {
          line: 94,
          column: 6
        },
        end: {
          line: 94,
          column: 22
        }
      },
      "35": {
        start: {
          line: 99,
          column: 25
        },
        end: {
          line: 99,
          column: 39
        }
      },
      "36": {
        start: {
          line: 100,
          column: 24
        },
        end: {
          line: 100,
          column: 37
        }
      },
      "37": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 105,
          column: 5
        }
      },
      "38": {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 104,
          column: 68
        }
      },
      "39": {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 119,
          column: 5
        }
      },
      "40": {
        start: {
          line: 123,
          column: 24
        },
        end: {
          line: 123,
          column: 34
        }
      },
      "41": {
        start: {
          line: 124,
          column: 32
        },
        end: {
          line: 124,
          column: 42
        }
      },
      "42": {
        start: {
          line: 125,
          column: 25
        },
        end: {
          line: 125,
          column: 40
        }
      },
      "43": {
        start: {
          line: 127,
          column: 19
        },
        end: {
          line: 127,
          column: 21
        }
      },
      "44": {
        start: {
          line: 129,
          column: 4
        },
        end: {
          line: 129,
          column: 90
        }
      },
      "45": {
        start: {
          line: 130,
          column: 4
        },
        end: {
          line: 130,
          column: 57
        }
      },
      "46": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 132,
          column: 87
        }
      },
      "47": {
        start: {
          line: 132,
          column: 29
        },
        end: {
          line: 132,
          column: 87
        }
      },
      "48": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 133,
          column: 88
        }
      },
      "49": {
        start: {
          line: 133,
          column: 29
        },
        end: {
          line: 133,
          column: 88
        }
      },
      "50": {
        start: {
          line: 135,
          column: 4
        },
        end: {
          line: 135,
          column: 17
        }
      },
      "51": {
        start: {
          line: 139,
          column: 0
        },
        end: {
          line: 141,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        loc: {
          start: {
            line: 37,
            column: 28
          },
          end: {
            line: 50,
            column: 3
          }
        },
        line: 37
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        loc: {
          start: {
            line: 52,
            column: 22
          },
          end: {
            line: 55,
            column: 3
          }
        },
        line: 52
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 57,
            column: 2
          },
          end: {
            line: 57,
            column: 3
          }
        },
        loc: {
          start: {
            line: 57,
            column: 25
          },
          end: {
            line: 60,
            column: 3
          }
        },
        line: 57
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 62,
            column: 3
          }
        },
        loc: {
          start: {
            line: 62,
            column: 30
          },
          end: {
            line: 64,
            column: 3
          }
        },
        line: 62
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 66,
            column: 2
          },
          end: {
            line: 66,
            column: 3
          }
        },
        loc: {
          start: {
            line: 66,
            column: 33
          },
          end: {
            line: 81,
            column: 3
          }
        },
        line: 66
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 69,
            column: 12
          },
          end: {
            line: 69,
            column: 13
          }
        },
        loc: {
          start: {
            line: 69,
            column: 21
          },
          end: {
            line: 74,
            column: 7
          }
        },
        line: 69
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 75,
            column: 7
          }
        },
        loc: {
          start: {
            line: 75,
            column: 12
          },
          end: {
            line: 79,
            column: 7
          }
        },
        line: 75
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 76,
            column: 19
          },
          end: {
            line: 76,
            column: 20
          }
        },
        loc: {
          start: {
            line: 76,
            column: 25
          },
          end: {
            line: 78,
            column: 9
          }
        },
        line: 76
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 83,
            column: 2
          },
          end: {
            line: 83,
            column: 3
          }
        },
        loc: {
          start: {
            line: 83,
            column: 30
          },
          end: {
            line: 96,
            column: 3
          }
        },
        line: 83
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 93,
            column: 34
          },
          end: {
            line: 93,
            column: 35
          }
        },
        loc: {
          start: {
            line: 93,
            column: 40
          },
          end: {
            line: 95,
            column: 5
          }
        },
        line: 93
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 98,
            column: 2
          },
          end: {
            line: 98,
            column: 3
          }
        },
        loc: {
          start: {
            line: 98,
            column: 48
          },
          end: {
            line: 120,
            column: 3
          }
        },
        line: 98
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 122,
            column: 2
          },
          end: {
            line: 122,
            column: 3
          }
        },
        loc: {
          start: {
            line: 122,
            column: 11
          },
          end: {
            line: 136,
            column: 3
          }
        },
        line: 122
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 73,
            column: 71
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 73,
            column: 71
          }
        }, {
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 73,
            column: 71
          }
        }],
        line: 71
      },
      "1": {
        loc: {
          start: {
            line: 72,
            column: 13
          },
          end: {
            line: 73,
            column: 71
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 72,
            column: 13
          },
          end: {
            line: 73,
            column: 71
          }
        }, {
          start: {
            line: 72,
            column: 13
          },
          end: {
            line: 73,
            column: 71
          }
        }],
        line: 72
      },
      "2": {
        loc: {
          start: {
            line: 73,
            column: 31
          },
          end: {
            line: 73,
            column: 71
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 73,
            column: 49
          },
          end: {
            line: 73,
            column: 58
          }
        }, {
          start: {
            line: 73,
            column: 61
          },
          end: {
            line: 73,
            column: 71
          }
        }],
        line: 73
      },
      "3": {
        loc: {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 84,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 84,
            column: 30
          }
        }, {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 84,
            column: 30
          }
        }],
        line: 84
      },
      "4": {
        loc: {
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 86,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 86,
            column: 34
          }
        }, {
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 86,
            column: 34
          }
        }],
        line: 86
      },
      "5": {
        loc: {
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 90,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 90,
            column: 46
          }
        }, {
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 90,
            column: 46
          }
        }],
        line: 90
      },
      "6": {
        loc: {
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 91,
            column: 45
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 91,
            column: 45
          }
        }, {
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 91,
            column: 45
          }
        }],
        line: 91
      },
      "7": {
        loc: {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        }, {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        }],
        line: 103
      },
      "8": {
        loc: {
          start: {
            line: 104,
            column: 44
          },
          end: {
            line: 104,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 104,
            column: 61
          },
          end: {
            line: 104,
            column: 63
          }
        }, {
          start: {
            line: 104,
            column: 66
          },
          end: {
            line: 104,
            column: 67
          }
        }],
        line: 104
      },
      "9": {
        loc: {
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 132,
            column: 87
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 132,
            column: 87
          }
        }, {
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 132,
            column: 87
          }
        }],
        line: 132
      },
      "10": {
        loc: {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 133,
            column: 88
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 133,
            column: 88
          }
        }, {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 133,
            column: 88
          }
        }],
        line: 133
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Image/Gallery.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
import icons from '../icons';
import Magnify from './Magnify';
import { imageClass } from './styles';
import { PureComponent } from '../component';
import { docSize } from '../utils/dom/document';
import normalizeWheel from '../utils/dom/normalizeWheel';
var DefaultProps = (cov_ib1vah66i.s[0]++, {
  current: 0
});

var Gallery =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Gallery, _PureComponent);

  var _super = _createSuper2(Gallery);

  function Gallery(props) {
    var _this;

    _classCallCheck(this, Gallery);

    cov_ib1vah66i.f[0]++;
    cov_ib1vah66i.s[1]++;
    _this = _super.call(this, props);
    _this.scrollX = void 0;
    _this.rawScroll = void 0;
    _this.scrollTimer = void 0;
    cov_ib1vah66i.s[2]++;
    _this.state = {
      current: props.current,
      direction: 'init'
    };
    cov_ib1vah66i.s[3]++;
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    cov_ib1vah66i.s[4]++;
    _this.lockScroll = _this.lockScroll.bind(_assertThisInitialized(_this));
    cov_ib1vah66i.s[5]++;
    _this.scrollX = 0;
    cov_ib1vah66i.s[6]++;
    _this.rawScroll = false;
    return _this;
  }

  _createClass(Gallery, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_ib1vah66i.f[1]++;
      cov_ib1vah66i.s[7]++;

      _get(_getPrototypeOf(Gallery.prototype), "componentDidMount", this).call(this);

      cov_ib1vah66i.s[8]++;
      document.addEventListener('wheel', this.handleScroll, {
        passive: false
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_ib1vah66i.f[2]++;
      cov_ib1vah66i.s[9]++;

      _get(_getPrototypeOf(Gallery.prototype), "componentWillUnmount", this).call(this);

      cov_ib1vah66i.s[10]++;
      document.removeEventListener('wheel', this.handleScroll, {
        passive: false
      });
    }
  }, {
    key: "lockScroll",
    value: function lockScroll(status) {
      cov_ib1vah66i.f[3]++;
      cov_ib1vah66i.s[11]++;
      this.rawScroll = status;
    }
  }, {
    key: "handleClick",
    value: function handleClick(direction) {
      var _this2 = this;

      cov_ib1vah66i.f[4]++;

      var _ref = (cov_ib1vah66i.s[12]++, this.props.images),
          length = _ref.length;

      cov_ib1vah66i.s[13]++;
      this.setState(immer(function (draft) {
        cov_ib1vah66i.f[5]++;
        cov_ib1vah66i.s[14]++;
        draft.current += direction;
        cov_ib1vah66i.s[15]++;

        if (draft.current < 0) {
          cov_ib1vah66i.b[0][0]++;
          cov_ib1vah66i.s[16]++;
          draft.current = 0;
        } else {
          cov_ib1vah66i.b[0][1]++;
          cov_ib1vah66i.s[17]++;

          if (draft.current >= length) {
            cov_ib1vah66i.b[1][0]++;
            cov_ib1vah66i.s[18]++;
            draft.current = length - 1;
          } else {
            cov_ib1vah66i.b[1][1]++;
            cov_ib1vah66i.s[19]++;
            draft.direction = direction === 1 ? (cov_ib1vah66i.b[2][0]++, 'forward') : (cov_ib1vah66i.b[2][1]++, 'backward');
          }
        }
      }), function () {
        cov_ib1vah66i.f[6]++;
        cov_ib1vah66i.s[20]++;
        setTimeout(function () {
          cov_ib1vah66i.f[7]++;
          cov_ib1vah66i.s[21]++;

          _this2.setState({
            direction: 'init'
          });
        }, 400);
      });
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(e) {
      var _this3 = this;

      cov_ib1vah66i.f[8]++;
      cov_ib1vah66i.s[22]++;

      if (this.rawScroll) {
        cov_ib1vah66i.b[3][0]++;
        cov_ib1vah66i.s[23]++;
        return;
      } else {
        cov_ib1vah66i.b[3][1]++;
      }

      cov_ib1vah66i.s[24]++;
      e.preventDefault();
      cov_ib1vah66i.s[25]++;

      if (this.scrollX !== 0) {
        cov_ib1vah66i.b[4][0]++;
        cov_ib1vah66i.s[26]++;
        return;
      } else {
        cov_ib1vah66i.b[4][1]++;
      }

      var wheel = (cov_ib1vah66i.s[27]++, normalizeWheel(e));
      cov_ib1vah66i.s[28]++;
      this.scrollX += wheel.spinX;
      cov_ib1vah66i.s[29]++;

      if (this.scrollX < 0) {
        cov_ib1vah66i.b[5][0]++;
        cov_ib1vah66i.s[30]++;
        this.handleClick(-1);
      } else {
        cov_ib1vah66i.b[5][1]++;
      }

      cov_ib1vah66i.s[31]++;

      if (this.scrollX > 0) {
        cov_ib1vah66i.b[6][0]++;
        cov_ib1vah66i.s[32]++;
        this.handleClick(1);
      } else {
        cov_ib1vah66i.b[6][1]++;
      }

      cov_ib1vah66i.s[33]++;
      this.scrollTimer = setTimeout(function () {
        cov_ib1vah66i.f[9]++;
        cov_ib1vah66i.s[34]++;
        _this3.scrollX = 0;
      }, 1000);
    }
  }, {
    key: "renderImage",
    value: function renderImage(image, pos) {
      cov_ib1vah66i.f[10]++;
      var windowHeight = (cov_ib1vah66i.s[35]++, docSize.height);
      var windowWidth = (cov_ib1vah66i.s[36]++, docSize.width);
      var onClick;
      cov_ib1vah66i.s[37]++;

      if (pos !== 'center') {
        cov_ib1vah66i.b[7][0]++;
        cov_ib1vah66i.s[38]++;
        onClick = this.handleClick.bind(this, pos === 'left' ? (cov_ib1vah66i.b[8][0]++, -1) : (cov_ib1vah66i.b[8][1]++, 1));
      } else {
        cov_ib1vah66i.b[7][1]++;
      }

      cov_ib1vah66i.s[39]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          key: image.key,
          className: imageClass(pos, this.state.direction),
          onClick: onClick,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 107,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("a", {
          onClick: this.props.onClose,
          className: imageClass('close'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 108,
            columnNumber: 9
          }
        }, icons.Close),
        /*#__PURE__*/
        React.createElement(Magnify, {
          maxWidth: windowWidth - 400,
          maxHeight: windowHeight - 160,
          position: pos,
          src: image.src,
          lockScroll: this.lockScroll,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 111,
            columnNumber: 9
          }
        }))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_ib1vah66i.f[11]++;

      var _ref2 = (cov_ib1vah66i.s[40]++, this.state),
          current = _ref2.current;

      var _ref3 = (cov_ib1vah66i.s[41]++, this.props),
          images = _ref3.images,
          onClose = _ref3.onClose;

      var currentImage = (cov_ib1vah66i.s[42]++, images[current]);
      var result = (cov_ib1vah66i.s[43]++, []);
      cov_ib1vah66i.s[44]++;
      result.push(
      /*#__PURE__*/
      React.createElement("div", {
        key: "overlay",
        className: imageClass('overlay'),
        onClick: onClose,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 129,
          columnNumber: 17
        }
      }));
      cov_ib1vah66i.s[45]++;
      result.push(this.renderImage(currentImage, 'center'));
      cov_ib1vah66i.s[46]++;

      if (images[current - 1]) {
        cov_ib1vah66i.b[9][0]++;
        cov_ib1vah66i.s[47]++;
        result.push(this.renderImage(images[current - 1], 'left'));
      } else {
        cov_ib1vah66i.b[9][1]++;
      }

      cov_ib1vah66i.s[48]++;

      if (images[current + 1]) {
        cov_ib1vah66i.b[10][0]++;
        cov_ib1vah66i.s[49]++;
        result.push(this.renderImage(images[current + 1], 'right'));
      } else {
        cov_ib1vah66i.b[10][1]++;
      }

      cov_ib1vah66i.s[50]++;
      return result;
    }
  }]);

  return Gallery;
}(PureComponent);

Gallery.defaultProps = DefaultProps;
cov_ib1vah66i.s[51]++;
Gallery.defaultProps = {
  current: 0
};
export default Gallery;